(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("hammerjs"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["PhotoView"] = factory(require("hammerjs"));
	else
		root["PhotoView"] = factory(root["Hammer"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _hammerjs = __webpack_require__(3);
	
	var _hammerjs2 = _interopRequireDefault(_hammerjs);
	
	var _customEvent = __webpack_require__(2);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PhotoViewManager = function () {
	  function PhotoViewManager() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, PhotoViewManager);
	
	    var defaultOptions = {
	      maxScale: 2,
	      enableMultiZoom: false,
	      snapToGrid: true,
	      tapToZoom: false
	    };
	
	    this.options = Object.assign(defaultOptions, options);
	    return this;
	  }
	
	  _createClass(PhotoViewManager, [{
	    key: 'init',
	    value: function init(selector) {
	      var container = typeof selector === 'string' ? document.querySelectorAll(selector)[0] : selector;
	      if (!container) {
	        console.warn('You must provide a valid container for PhotoView (selector "' + selector + '" did not match any element)');
	        return;
	      }
	
	      this.image = container.querySelectorAll('img')[0];
	      if (!this.image) {
	        console.warn('You must have a valid img tag inside your container');
	        return;
	      }
	
	      this._manager = new _hammerjs2.default.Manager(this.image, { touchAction: 'pan-y' });
	      this._registerGestures();
	      this._registerEvents();
	      this.scale = 1;
	      this.deltaX = 0;
	      this.deltaY = 0;
	      return this;
	    }
	  }, {
	    key: '_dispatchEvent',
	    value: function _dispatchEvent(type, detail) {
	      var event = new _customEvent2.default(type, {
	        bubbles: true,
	        cancelable: true,
	        detail: detail
	      });
	
	      document.dispatchEvent(event);
	    }
	  }, {
	    key: '_registerGestures',
	    value: function _registerGestures() {
	      var tap = new _hammerjs2.default.Tap({ event: 'zoom', taps: 1 });
	      var doubleTap = new _hammerjs2.default.Tap({ event: 'zoom', taps: 2 });
	      var pan = new _hammerjs2.default.Pan({ direction: _hammerjs2.default.DIRECTION_ALL, threshold: 10 });
	      var pinch = new _hammerjs2.default.Pinch();
	      var gestures = [pinch, doubleTap, pan];
	      if (this.options.tapToZoom) {
	        doubleTap.recognizeWith(tap);
	        tap.requireFailure(doubleTap);
	        gestures.splice(2, -1, tap);
	      }
	
	      this._manager.add(gestures);
	    }
	  }, {
	    key: '_getZoomLevel',
	    value: function _getZoomLevel() {
	      var scale = void 0;
	      if (this.options.enableMultiZoom) {
	        var midScale = this.options.maxScale / 2;
	        scale = this.scale === 1 ? midScale : this.scale === midScale ? this.options.maxScale : 1;
	      } else {
	        scale = this.scale > 1 ? 1 : this.options.maxScale;
	      }
	
	      return scale;
	    }
	  }, {
	    key: 'handleTouchEvent',
	    value: function handleTouchEvent() {
	      this._dispatchEvent('photoview.scale.changed', { scale: this.scale });
	    }
	  }, {
	    key: '_registerEvents',
	    value: function _registerEvents() {
	      var _this = this;
	
	      this._manager.on('zoom', function (e) {
	        var _e$center = e.center;
	        var x = _e$center.x;
	        var y = _e$center.y;
	
	        var scale = _this._getZoomLevel();
	        _this._setTransition(true);
	        _this._transform(x, y, scale);
	        _this.handleTouchEvent();
	      });
	
	      this._manager.on('pinchstart', function (e) {
	        clearTimeout(_this.panTimer);
	        _this._enableGesture('pan', false);
	        var _e$center2 = e.center;
	        var x = _e$center2.x;
	        var y = _e$center2.y;
	
	        _this._setTransition(true);
	
	        if (_this.scale === 1) {
	          _this.pinchX = x;
	          _this.pinchY = y;
	        }
	      });
	
	      this._manager.on('pinch', function (e) {
	        if (e.additionalEvent === 'pinchout') {
	          _this._transform(_this.pinchX, _this.pinchY, _this.options.maxScale);
	        } else if (e.additionalEvent === 'pinchin') {
	          _this._transform(0, 0, 1);
	        }
	
	        _this.handleTouchEvent();
	      });
	
	      this._manager.on('pinchend', function (e) {
	        _this.panTimer = setTimeout(function (_) {
	          return _this._enableGesture('pan', true);
	        }, 1000);
	      });
	
	      this._manager.on('panstart', function (e) {
	        _this._setTransition(false);
	      });
	
	      this._manager.on('pan', function (e) {
	        if (_this.scale === 1) {
	          return;
	        }
	
	        e.srcEvent.stopPropagation();
	        _this.currentDeltaX = (isNaN(_this.deltaX) ? 0 : _this.deltaX) + e.deltaX;
	        _this.currentDeltaY = (isNaN(_this.deltaY) ? 0 : _this.deltaY) + e.deltaY;
	        if (_this.options.snapToGrid) {
	          _this._adjustSnapPositions();
	        }
	
	        _this._setTransition(false);
	        _this.image.style.transform = 'translate3d(' + _this.currentDeltaX + 'px, ' + _this.currentDeltaY + 'px, 0px) scale(' + _this.scale + ')';
	      });
	
	      this._manager.on('panend', function (e) {
	        _this.deltaX = _this.currentDeltaX;
	        _this.deltaY = _this.currentDeltaY;
	      });
	    }
	  }, {
	    key: '_adjustSnapPositions',
	    value: function _adjustSnapPositions() {
	      var imageOffsetLeft = this.image.offsetLeft;
	      var imageOffsetTop = this.image.offsetTop;
	      if (this.currentDeltaX + imageOffsetLeft > this.x) {
	        this.currentDeltaX = this.x - imageOffsetLeft;
	      } else if (this.x - this.currentDeltaX + imageOffsetLeft > this.image.width) {
	        var adjustWidth = this.x - this.currentDeltaX + imageOffsetLeft - this.image.width;
	        this.currentDeltaX = this.currentDeltaX + adjustWidth;
	      }
	
	      if (this.currentDeltaY + imageOffsetTop > this.y) {
	        this.currentDeltaY = this.y - imageOffsetTop;
	      } else if (this.y - this.currentDeltaY + imageOffsetTop > this.image.height) {
	        var adjustHeight = this.y - this.currentDeltaY + imageOffsetTop - this.image.height;
	        this.currentDeltaY = this.currentDeltaY + adjustHeight;
	      }
	    }
	  }, {
	    key: '_transform',
	    value: function _transform(x, y, scale) {
	      if (scale === 1) {
	        x = this.x;y = this.y;
	      } else {
	        x -= this.image.offsetLeft;
	        y -= this.image.offsetTop;
	      }
	
	      this.image.style['transformOrigin'] = x + 'px ' + y + 'px';
	      this.image.style.transform = 'scale3d(' + scale + ',' + scale + ',1)';
	      this.x = x;
	      this.y = y;
	      this.scale = scale;
	      this._onTransformEnd();
	    }
	  }, {
	    key: '_onTransformEnd',
	    value: function _onTransformEnd() {
	      if (this.scale <= 1) {
	        this.deltaX = this.deltaY = 0;
	      }
	    }
	  }, {
	    key: '_enableGesture',
	    value: function _enableGesture(gesture, value) {
	      this._manager.get(gesture).set({ enable: value });
	    }
	  }, {
	    key: '_setTransition',
	    value: function _setTransition(value) {
	      this.image.style.transition = value ? 'transform 0.5s' : 'none';
	    }
	  }, {
	    key: '_unregisterEvents',
	    value: function _unregisterEvents() {
	      this._manager.off('pan');
	      this._manager.off('pinch');
	      this._manager.off('zoom');
	    }
	  }, {
	    key: 'reset',
	    value: function reset(animate) {
	      if (animate) {
	        this._setTransition(true);
	        this._transform(0, 0, 1);
	        this._setTransition(false);
	      } else {
	        this.image.style.transform = 'none';
	      }
	      this.resetScale();
	    }
	  }, {
	    key: 'resetScale',
	    value: function resetScale() {
	      this.scale = 1;
	      this._dispatchEvent('photoview.scale.changed', { scale: this.scale });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this._unregisterEvents();
	      this._manager = null;
	    }
	  }]);
	
	  return PhotoViewManager;
	}();
	
	var PhotoView = function () {
	  function PhotoView(selector) {
	    var _this2 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, PhotoView);
	
	    this.instances = [];
	    var slice = Array.prototype.slice;
	    var elements = slice.call(document.querySelectorAll(selector));
	    elements.forEach(function (item) {
	      _this2.instances.push(new PhotoViewManager(options).init(item));
	    });
	  }
	
	  _createClass(PhotoView, [{
	    key: 'reset',
	    value: function reset() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var _ref$animate = _ref.animate;
	      var animate = _ref$animate === undefined ? false : _ref$animate;
	
	      this.instances.forEach(function (photoViewInstance) {
	        photoViewInstance.reset(animate);
	      });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.instances.forEach(function (photoViewInstance) {
	        photoViewInstance.destroy();
	      });
	
	      this.instances = null;
	    }
	  }]);
	
	  return PhotoView;
	}();
	
	exports.default = PhotoView;
	module.exports = exports['default'];

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	
	var NativeCustomEvent = ({}).CustomEvent;
	
	function useNative () {
	  try {
	    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
	    return  'cat' === p.type && 'bar' === p.detail.foo;
	  } catch (e) {
	  }
	  return false;
	}
	
	/**
	 * Cross-browser `CustomEvent` constructor.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
	 *
	 * @public
	 */
	
	module.exports = useNative() ? NativeCustomEvent :
	
	// IE >= 9
	'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent (type, params) {
	  var e = document.createEvent('CustomEvent');
	  if (params) {
	    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
	  } else {
	    e.initCustomEvent(type, false, false, void 0);
	  }
	  return e;
	} :
	
	// IE <= 8
	function CustomEvent (type, params) {
	  var e = document.createEventObject();
	  e.type = type;
	  if (params) {
	    e.bubbles = Boolean(params.bubbles);
	    e.cancelable = Boolean(params.cancelable);
	    e.detail = params.detail;
	  } else {
	    e.bubbles = false;
	    e.cancelable = false;
	    e.detail = void 0;
	  }
	  return e;
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** build.js
 **/